import {styled} from "@mui/material/styles"
import {mobileThreshold, portfolioWidth } from "../../Constants/layoutValues";
import {cssVarColors} from "../../Constants";

export const HomePageWrapper = styled('div')`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	width: 100%;
`

export const Wrapper = styled('div')`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`;

export const SectionWrapper = styled('div')`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${cssVarColors.surface};
	:nth-of-type(odd)
	{
		background-color: ${cssVarColors.surfaceAlternate};
	}
`;

export const SectionContent = styled('div')`
	width: min(${portfolioWidth}, 100%);
`;


export const SectionTitle = styled('div')`
	font-size: 1.6rem;
	//font-family: dalafloda;
	font-size: 2.5rem;
	text-align: center;
	position: relative;
	margin-bottom: 0rem;
	color: ${cssVarColors.primary};
	
	// ::after
	// {
	// 	content: '';
	// 	display: block;
	// 	width: 30rem;
	// 	height: 3px;
	// 	background-color: ${cssVarColors.highlight}; /* Adjust to match your brand color */
	// 	margin: 0.5rem auto 0 auto;
	// 	border-radius: 2px;
	// 	@media (max-width: ${mobileThreshold}px)
	// 	{
	// 		width: 60vw;
	// 	};
	// }

	@media (max-width: ${mobileThreshold}px)
	{
		font-size: 2rem;
	};
`;
